var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._m(0),_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"offset-md-4 col-md-4 col"},[_vm._t("default")],2)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"offset-md-4 col-md-4 col text-center"},[_c('img',{attrs:{"src":"/img/logo-greendid-header.png","width":"180"}})])])
}]

export { render, staticRenderFns }